import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory, Link } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarCanchas from "../element/CarCanchas";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
import Menu from "./Menu";
// Estilos
import "../css/styleEspaciosDeportivos.css";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import Horas from "../hooks/HorasEspaciosDeportivos";
// import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from "./Footer";

const Canchas = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;

    // SetBitacora.set(cred.carnet, 'Canchas', cred.token);
  } else {
    history.push("/");
  }

  const [reservas, setReservas] = useState();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    GetFetch.getDeportiosReservasAlumno(dataUser.carnet).then((data) => {
      if (data.length > 0) {
        setReservas(data);
      } else {
        setReservas(0);
      }
      setCargando(false);
    }).catch(() => setCargando(false));
    loadMenu();
  }, [dataUser.carnet]);

  let correlativo = 0;

  let formatoFecha = (fecha) => {
    let dia = fecha.substr(0, 2);
    let mes = fecha.substr(3, 2);
    let anio = fecha.substr(6, 4);

    return anio + "-" + mes + "-" + dia;
  };

  //Formato para calendario del navegador
  function FechaActual(i = 0) {
    let fecha = new Date(Date.now());

    let dd = fecha.getDate() + i;
    let mm = fecha.getMonth() + 1;
    let yyyy = fecha.getFullYear();

    if (mm < 10) {
      mm = "0" + mm;
    }

    if (dd < 10) {
      dd = "0" + dd;
    }

    return yyyy + "-" + mm + "-" + dd;
  }

  //CancelarReservas
  const btnCancelarReserva = (e) => {
    let _id = e.target.dataset.id;
    let carnet = e.target.dataset.carnet;
    let stado = "2";
    let spacios_libres = e.target.dataset.libres;
    let spacios_reservados = e.target.dataset.reservados;
    let hora_inicio = e.target.dataset.inicio;
    let hora_fin = e.target.dataset.fin;

    let idElemento = e.target.dataset.iid;

    const data = new FormData();
    data.append("secret", "5ec4702eff406849a82818cb");
    data.append("_id", _id);
    data.append("carnet", carnet);
    data.append("stado", stado);
    data.append("spacios_libres", spacios_libres);
    data.append("spacios_reservados", spacios_reservados);
    data.append("hora_inicio", hora_inicio);
    data.append("hora_fin", hora_fin);
    data.append(
      "horas",
      Horas.horas[hora_inicio] + " / " + Horas.horas[hora_fin]
    );

    GetFetch.setDeportiosCancelarReservaAlumno(data, dataUser.token).then(
      (data) => {
        if (+data.success === 1) {
          document.getElementById(idElemento).style.display = "none";
        }
      }
    );

    console.log(_id, carnet, spacios_libres, spacios_reservados);
  };

  // Catálogo de espacios disponibles (solo presentación)
  const espacios = [
    { ruta: "/canchafutbol", nombre: "Football", icono: "fa-futbol-o" },
    { ruta: "/canchabasketsalafutvolei", nombre: "Basketball", icono: "fa-dribbble" },
    { ruta: "/canchafootballsala", nombre: "Football sala", icono: "fa-futbol-o" },
    { ruta: "/canchabasvoleibol", nombre: "Voleibol", icono: "fa-hand-paper-o" },
    { ruta: "/canchapp1", nombre: "Tenis de mesa 1", icono: "fa-dot-circle-o" },
    { ruta: "/canchapp2", nombre: "Tenis de mesa 2", icono: "fa-dot-circle-o" },
  ];

  // Reservas con fecha vigente (mismo criterio que antes, solo presentación)
  const reservasVigentes = Array.isArray(reservas)
    ? reservas.filter((elemento) => {
        let fechaLimite = new Date(formatoFecha(elemento.fecha));
        let fechaPresente = new Date(FechaActual());
        return fechaLimite >= fechaPresente;
      })
    : [];

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Espacios deportivos</h2>
        <p className="text-muted mb-3">
          Elige el espacio que quieres reservar.
        </p>
        <div className="esen-espacios-grid">
          {espacios.map((espacio) => (
            <Link
              key={espacio.ruta}
              className="esen-espacio-card"
              to={espacio.ruta}
            >
              <span className="esen-espacio-icon">
                <i className={`fa ${espacio.icono}`} aria-hidden="true"></i>
              </span>
              {espacio.nombre}
            </Link>
          ))}
        </div>

        <h3 className="h5 mb-3">Mis reservas</h3>
        {cargando ? (
          <SkeletonCard rows={3} />
        ) : reservasVigentes.length > 0 ? (
          reservasVigentes.map((elemento, key) => {
            correlativo++;
            return (
              <div key={"bljd" + key}>
                <div className="card mb-3">
                  <div className="card-header">
                    <i className="fa fa-calendar-check-o mr-2" aria-hidden="true"></i>
                    Reserva n.º {correlativo}
                  </div>
                  <CarCanchas
                    reservasData={elemento.reservas}
                    fecha={elemento.fecha}
                    espacio={elemento.espacio}
                    Horas={Horas}
                    spacios_libres={elemento.spacios_libres}
                    spacios_reservados={elemento.spacios_reservados}
                    _id={elemento._id}
                    btnCancelarReserva={btnCancelarReserva}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <EmptyState icon="fa-futbol-o" title="Aún no tienes reservas vigentes">
            Elige un espacio deportivo arriba para hacer tu primera reserva.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default Canchas;
